import {getDwellingMetrics} from "../../api/GetViewMetrics";
import {getPackageResults} from "../../api/GetDrillDownResults";
 
export const ViewDataReducer = (state, action) => {

    switch (action.type) {

        case "LOAD_VIEW":

            const {filters, stationCode, view, dispatcher, leg, prevView, isCPTFilter, filterDispatcher, size} = action.data;
            state.isLoading = true;
            if (action.data.view === "AGEING_VIEW" || action.data.view === "RTS_VIEW" || action.data.view === "DWELLING_VIEW"
                || action.data.view === "SD_DWELLING_VIEW") {
                getDwellingMetrics(filters, stationCode, view, dispatcher ,leg, isCPTFilter)
            } else
            {
                state.packageResultList = [];
                getPackageResults(filters, stationCode, prevView, leg , dispatcher, isCPTFilter, filterDispatcher, size)
            }
            return {...state }

        case "UNLOAD_VIEW":
  
            return state    
        case "RECEIVED_DATA":
            return {...state, ...action.data}
        case "SET_BASE_URL":
            return {...state, baseURL : action.data};
        default:
            return state

    }
}


// WEBPACK FOOTER //
// ./src/commons/reducer/view/DataReducer.js